import axios from "axios";

export default {
    getRelatedTasks: async (projectId, accountId, clientId, taskId, virtualId, date, keyword) => {
        const { data } = await axios.get(`/task/related_tasks/`, { params: {
            project_id: projectId,
            account_id: accountId,
            client_id: clientId,
            task_id: taskId,
            virtual_id: virtualId,
            date: date,
            keyword: keyword ? keyword : ''
        }})

        return data
    },
    getClientTaskTemplates: async (clientId) => {
        const { data } = await axios.get('/tasktemplates/', {
            params: {
                object_id: clientId
            }
        })

        return data
    },
    getNonRecurringTemplateTasks: async (search) => {
        const params = {}
        if (search) {
            params.search = search
        }

        const { data } = await axios.get(`/non_recurring_template_tasks/`, { params })

        return data
    }
}
